export default __webpack_public_path__ + "static/media/blurb_cloud_left.f4a5eac9.svg";